import styled from "styled-components";
import SubscriptionOperationsGrid from "../../components/SubscriptionOperationsGrid";
import React from "react";
import { ScrollView } from "devextreme-react";

const SubListContainer = styled.div``;

function SubscriptionRequest() {
  return (
    <ScrollView height={window.innerHeight - 150} direction="vertical">
      <SubListContainer>
        <SubscriptionOperationsGrid operation={"Create"} />
      </SubListContainer>
    </ScrollView>
  );
}

export default SubscriptionRequest;
